
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns0cc3fc104153c65d94416a94a2d92062en from './en.yaml'
            i18n.addResourceBundle('en', '0cc3fc104153c65d94416a94a2d92062', flattenObject(ns0cc3fc104153c65d94416a94a2d92062en), true, true);
        
        export default '0cc3fc104153c65d94416a94a2d92062';
    